import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ApplicationState } from "../../store";
import * as BannerMessageActions from "../../store/bannerMessage/actions";
import { AlertMessageBanner } from "../../store/bannerMessage/types";
import parse from "html-react-parser";
import BreachBannerMessage from "../Breaches/BreachBannerMessage";
import { checkSMGEvent, getAccountSummary, dismissMxMigrAlertMessage, mxMigrAlertMessageStatus } from "../../store/service";
import { useTranslation } from "react-i18next";
import { enableMXForIDF } from "../../config/UserServicesList";
export enum msgLevel {
    CRITICAL = "CRITICAL",
    IMPORTANT = "IMPORTANT",
    INFORMATION = "INFORMATION",
    DEBUG = "DEBUG",
}
const BannerMessage: React.FunctionComponent<{ layout: string }> = (props) => {
    const dispatch = useDispatch();
    const alertMessageBannerList = useSelector((state: ApplicationState) =>
        state.alertMessageBannerState ? state.alertMessageBannerState.alertMessageBanner : []
    );
    const accountSummaryData = useSelector((state: ApplicationState) =>
        state.accountSummaryData && state.accountSummaryData.accountSummaryData && state.accountSummaryData.accountSummaryData.data
            ? state.accountSummaryData.accountSummaryData.data
            : []
    );

    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const { t: tLang, i18n: i18nLang } = useTranslation();
    let isIDFUser: any = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus && state.csidUserStatusState.csidUserStatus.isIDFUser ?
            state.csidUserStatusState.csidUserStatus.isIDFUser : false
    );
    const billingStatus: any = useSelector((state: ApplicationState) =>
        state.billingStatusState && state.billingStatusState.billingStatus ?
            state.billingStatusState.billingStatus : false
    );
    const isWhiteLabeledPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );
    const isAdultFamilyMember = useSelector((state: ApplicationState) =>
        state.familyServiceState && state.familyServiceState.isAdultFamilyMember ? state.familyServiceState.isAdultFamilyMember : false
    );


    const requestBannerMessage = (needToRefresh?: boolean) => dispatch(BannerMessageActions.actionCreators.getBannerAlertMessage(needToRefresh));
    const history: any = useHistory();
    const fromLogout = history && history.location.state ? history.location.state.from : "";
    const [showMigrBannerMsg, setShowMigrBannerMsg] = useState(false);
    useEffect(() => {
        if (!fromLogout) {
            if (props.layout === "login") {
                setTimeout(function () {
                    requestBannerMessage(true);
                }, 3000);
            } else {
                requestBannerMessage(true);
                const requestBody = isIDFUser ? { "eventKind": "AUTO_ENROLL_MX_SUBSCRIBER_SUCCESS" } : { "eventKind": "SUCCESS_IDF_MX_AUTO_ENROLLMENT" }
                checkSMGEvent(requestBody).then((data: any) => {
                    if (data.isSuccess) {
                        mxMigrAlertMessageStatus().then((data: any) => {
                            if (data.statusFlag) {
                                if (accountSummaryData.length > 0) {
                                    setShowMigrBannerMsg(false);
                                } else {
                                    getAccountSummary().then((acntData: any) => {
                                        if (!!!acntData.data || acntData.data.length <= 0) {
                                            setShowMigrBannerMsg(true);
                                        }
                                    })
                                }
                            }
                        }).catch((err: any) => {
                            console.log("Error while fetching status", err.message);
                        })
                    }
                });
            }
        }
    }, []);
    const onMigrMessageClose = () => {
        setShowMigrBannerMsg(false);
        dismissMxMigrAlertMessage().then((data: any) => {
        });
    };

    const yodleeToMxMigrationMsg = <div
        key={"banner-alert-message-migration"}
        style={{ display: "block" }}
        role="banner"
        className="m-sys-msg information"
    >
        <div className="l-page-container">
            <div className="sys-msg-content">
                <div className="flex">
                    <div className="flex">
                        <div className="fw-600">
                            We've updated our financial transaction alerts to be more reliable for you. To enjoy this new experience, please link your financial accounts and set your alert preferences.{' '}
                            <a href="/app/transactions/financial-account" style={{ whiteSpace: "nowrap" }}>Click here to set it up now!</a>
                        </div>
                    </div>
                    <span role="button" tabIndex={0} onClick={onMigrMessageClose} style={{ marginRight: "-20px" }}>
                        <em className="las la-times-circle inline-icon cursor-pointer"></em>
                    </span>
                </div>
            </div>
        </div>
    </div>;

    const csidUserStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );

    const isFailed = csidUserStatus?.["auth-status"]?.toLocaleLowerCase() === "locked" || csidUserStatus?.["auth-status"]?.toLocaleLowerCase() === "l3-otp-locked" || csidUserStatus?.["auth-status"]?.toLocaleLowerCase() === "l3-timeout-locked" ||
        csidUserStatus?.["auth-status"]?.toLocaleLowerCase() === "locked-not-enough-info"

    return (
        <React.Fragment>
            {props.layout === "login" &&
                alertMessageBannerList &&
                alertMessageBannerList
                    .filter((x) => x.displayScope == null || x.displayScope === "NONE")
                    .map((alert: AlertMessageBanner, index) => (
                        <div
                            key={"banner-alert-message-" + index}
                            style={{ display: "block" }}
                            role="banner"
                            className={
                                alert.messageLevel === msgLevel.CRITICAL
                                    ? "m-sys-msg alert"
                                    : alert.messageLevel === msgLevel.IMPORTANT
                                        ? "m-sys-msg info"
                                        : alert.messageLevel === msgLevel.INFORMATION
                                            ? "m-sys-msg information"
                                            : "m-sys-msg default"
                            }
                        >
                            <div className="l-page-container">
                                <div className="sys-msg-content" style={{ fontWeight: "750" }}> {alert ? parse(alert.message || "") : ""}</div>
                            </div>
                        </div>
                    ))}
            {props.layout === "default" &&
                alertMessageBannerList &&
                alertMessageBannerList.map((alert: AlertMessageBanner, index) => {
                    if (alert.allowDismiss) {
                        return <BreachBannerMessage alert={alert} index={index} />;
                    }
                })}
            {props.layout === "default" &&
                (billingStatus && !isWhiteLabeledPartner ?
                    <div
                        style={{ display: "block" }}
                        role="banner"
                        className="m-sys-msg information" >
                        <div className="l-page-container">
                            {isFailed &&
                                <div className="sys-msg-content" style={{ fontWeight: "600" }}>
                                    <span className="error-icon">
                                        <em className="las la-exclamation-triangle" style={{ fontSize: "1.2rem", color: "#ab170d" }}></em>&nbsp;
                                    </span>
                                    {tLang("dashboard.cancellationDialog.title")}
                                    <p className="fw-msg" style={{ fontWeight: "400" }}>
                                        {tLang("dashboard.cancellationDialog.descriptionMessages")}{" "}
                                        {tLang("dashboard.l3CommunicationDialog.ContactMessage1")}{" "}
                                        <a href={'tel:"' + partnerPhoneNumber + '"'}>
                                            {partnerPhoneNumber}
                                        </a>{" "}
                                        {tLang("dashboard.l3CommunicationDialog.ContactMessage2")}{" "}
                                        {tLang("dashboard.cancellationDialog.descriptionCancel")}
                                    </p>
                                </div>
                            }
                        </div>
                    </div> :
                    alertMessageBannerList &&
                    alertMessageBannerList
                        .filter((x) => (x.actorClass == "Partner.L3Cancellation" && x.displayScope == "AFTER_LOGIN"))
                        .map((alert: AlertMessageBanner, index) => (
                            <div
                                key={"banner-alert-message-" + index}
                                style={{ display: "block" }}
                                role="banner"
                                className="m-sys-msg information" >
                                <div className="l-page-container">
                                    {alert && isFailed &&
                                        <div className="sys-msg-content" style={{ fontWeight: "600" }}>
                                            <span className="error-icon">
                                                <em className="las la-exclamation-triangle" style={{ fontSize: "1.2rem", color: "#ab170d" }}></em>&nbsp;
                                            </span>
                                            {tLang("dashboard.cancellationDialog.title")}
                                            <p className="fw-msg" style={{ fontWeight: "400" }}>
                                                {tLang("dashboard.cancellationDialog.descriptionMessages")}{" "}
                                                {tLang("dashboard.l3CommunicationDialog.ContactMessage1")}{" "}
                                                <a href={'tel:"' + partnerPhoneNumber + '"'}>
                                                    {partnerPhoneNumber}
                                                </a>{" "}
                                                {tLang("dashboard.l3CommunicationDialog.ContactMessage2")}{" "}
                                                {tLang("dashboard.cancellationDialog.descriptionCancel")}
                                            </p>
                                        </div>

                                    }
                                </div>
                            </div>
                        ))
                )}
            {props.layout === "default" &&
                alertMessageBannerList &&
                alertMessageBannerList.map((alert: AlertMessageBanner, index) => {
                    <>
                        <div
                            key={"banner-alert-message-" + index}
                            style={{ display: "block" }}
                            role="banner"
                            className={
                                alert.messageLevel === msgLevel.CRITICAL
                                    ? "m-sys-msg alert"
                                    : alert.messageLevel === msgLevel.IMPORTANT
                                        ? "m-sys-msg info"
                                        : alert.messageLevel === msgLevel.INFORMATION
                                            ? "m-sys-msg information"
                                            : "m-sys-msg default"
                            }
                        >
                            <div className="l-page-container">
                                <div className="sys-msg-content" style={{ fontWeight: "750" }}>{alert ? parse(alert.message || "") : ""}</div>
                            </div>
                        </div>
                    </>

                })}
            {props.layout === "default" &&
                (isAdultFamilyMember &&
                    <div
                        style={{ display: "block" }}
                        role="banner"
                        className="m-sys-msg information" >
                        <div className="l-page-container">
                            {isFailed &&
                                <div className="sys-msg-content" style={{ fontWeight: "600" }}>
                                    <span className="error-icon">
                                        <em className="las la-exclamation-triangle" style={{ fontSize: "1.2rem", color: "#ab170d" }}></em>&nbsp;
                                    </span>
                                    {tLang("dashboard.l3CommunicationDialog.title")}
                                    <p className="fw-msg" style={{ fontWeight: "400" }}>
                                        {tLang("dashboard.l3CommunicationDialog.descriptionMessage1")}{" "}
                                        <strong>
                                            {tLang("dashboard.l3CommunicationDialog.descriptionMessage2")}
                                        </strong>{" "}
                                        {tLang("dashboard.l3CommunicationDialog.descriptionMessage3")}{" "}
                                        {tLang("dashboard.l3CommunicationDialog.ContactMessage1")}{" "}
                                        <a href={'tel:"' + partnerPhoneNumber + '"'}>
                                            {partnerPhoneNumber}
                                        </a>{" "}
                                        {tLang("dashboard.l3CommunicationDialog.ContactMessage2")}
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                )}

            {props.layout === "default" &&
                enableMXForIDF &&
                showMigrBannerMsg &&
                yodleeToMxMigrationMsg
            }
        </React.Fragment>
    );
};

export default BannerMessage;
